<template>
  <div class="header">
    <div class="header">
      <img class="head-img" src="@/assets/style2/img/banner.png">
      <div class="h-box">
        <div class="top">
          <div class="logo-box" @click="jump('/',{navIndex:1})">
            <div class="name-box">
              <div class="name">{{ info.fullName }}</div>
              <div class="en-name">{{ info.enName }}</div>
            </div>
          </div>
        </div>
        <Nav></Nav>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/style2/Nav.vue';
import {INFO} from '@/util/const';

export default {
  name: 'Head',
  components: {
    Nav,
  },
  computed: {
    tabIndex() {
      return this.$store.state.tabIndex;
    },
  },
  props: ['top'],
  data() {
    return {
      keyword: '',
      info: INFO,
    };
  },
  methods: {
    search() {
      this.$store.state.search = 1;
      this.$store.state.keyword = this.keyword;
    },
  },
};
</script>

<style scoped>
.head-img {
  position: absolute;
  right: -4px;
  top: 45px;
  width: 600px;
}

</style>
